// Please keep keys lowercase!
exports.supportedLanguages = {
    // en: 'English',
    'zh-hant': '繁體中文',
    // 'zh-hans': '简体中文',
};

exports.defaultLocale = 'zh-hant';